<template>
    <div
        ref="searchBody"
        v-on-scrollto.bottom.20="handleScrollBottom"
        :class="[single ? 'is-single' : '']"
        class="org-select-search-list"
    >
        <v-spinner
            v-if="searching"
            status="default"
            class="org-select-loading"
        />
        <template v-else>
            <v-tree
                v-if="records.length"
                ref="tree"
                :maps="maps"
                :options="records"
                :selected="selected"
                :single="single"
                :with-checkbox="withCheckbox"
                @change="selectedChange"
            >
                <template
                    slot="label"
                    slot-scope="props"
                >
                    <org-item
                        :option="props.options"
                        :tips="props.options.tips"
                    >
                        <!-- eslint-disable vue/no-v-html -->
                        <span
                            slot="text"
                            v-html="props.options.hName"
                        />
                    </org-item>
                </template>

                <!-- <template slot-scope="props" slot="item">
                    <a
                        class="v-tree__title"
                        :class="{
                            'is-selected': props.selected,
                            'has-selected': props.options.hasSelected
                        }"
                        @click="props.toggle"
                    >
                        <org-item :option="props.options">
                            <span slot="text" v-html="props.options.hName"></span>
                        </org-item>
                    </a>
                </template> -->
            </v-tree>
            <div
                v-else
                class="org-select-search-list-empty"
            >
                {{ currentKeywords ? tip : '' }}
            </div>
            <div
                v-show="!noMoreData"
                class="org-select-search-list-more"
            >
                <v-spinner :class="showLoadMore ? '' : 'is-hidden'">
                    加载更多
                </v-spinner>
            </div>
        </template>
    </div>
</template>

<script>
import { Icon, Spinner as VSpinner, Tree as VTree, OnScrollto as onScrollto } from 'vhtml-ui';
import { strEntity } from '@tencent/qd-lib';
import OrgItem from '@/components/org-item';
import { formatListData } from './utils/format';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
  directives: {
    'on-scrollto': onScrollto,
  },
  components: {
    VTree,
    VSpinner,
    OrgItem,
  },
  model: {
    prop: 'keywords',
    event: 'input',
  },
  props: {
    selected: {
      type: Array,
      default() {
        return [];
      },
    },

    keywords: {
      type: String,
      default: '',
    },

    single: Boolean,

    withCheckbox: {
      type: Boolean,
      default: false,
    },

    // 之前已经选中了的 跟selected同样不能选中，区别是显示样式不一样，并且不在右侧列表展示不可反选
    hisSelected: {
      type: Array,
      default() {
        return [];
      },
    },

    custFetchSearch: {
      type: Function,
      default: null,
    },

    custSearchList: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      searching: true,
      loading: false,
      currentKeywords: this.keywords,
      noMoreData: false,
      showLoadMore: true,
      records: [],
      index: 0,
      count: 15,
      tip: '无搜索结果',
      maps: {
        value: 'id',
        text: 'name',
      },
    };
  },
  watch: {
    keywords(val) {
      this.currentKeywords = val;
    },
  },
  methods: {
    selectedChange(sels, type) {
      const selsMap = sels.map((item) => {
        const newItem = { ...item };
        const regStart = new RegExp('<span class="highlight-keywords">', 'ig');
        const regEnd = new RegExp('</span>', 'ig');

        newItem.name = newItem.name.replace(regStart, '').replace(regEnd, '');

        return newItem;
      });

      this.$emit('change', selsMap, type);
    },
    handleScrollBottom() {
      if (this.noMoreData) {
        return;
      }
      this.showLoadMore = true;
      this.fetch(true);
    },
    fetch(touchBottom) {
      if (this.loading) {
        return;
      }

      if (!touchBottom) {
        this.searching = true;
        this.noMoreData = false;
        this.showLoadMore = false;
        this.records = [];
        this.index = 0;
      }

      this.loading = true;
      // let defer = this.$ajax.get('/call/settings/receptiongroup/users', {

      // console.log('gavintest');
      const defer = this.searchReq();

      if (this.index !== 0) {
        this.showLoadMore = true;
      }

      defer
        .then((res) => {
          // console.log(res);
          const { list, total } = res || {};

          let resList = list || [];
          if (this.custSearchList) {
            resList = this.custSearchList(resList);
          }

          let records = formatListData(resList, this.hisSelected) || [];

          const len = records.length;
          if (len === 0) {
            this.tip = '无搜索结果';
          }

          if (len < this.count || records.length >= total) {
            this.noMoreData = true;
          }

          records = records.map((item) => {
            const newItem = { ...item };

            if (this.currentKeywords !== '') {
              const placeholder = '__KEYWORD__';
              const reg = new RegExp(this.currentKeywords, 'ig');
              const pReg = new RegExp(placeholder, 'g');
              const str = `<span class="highlight-keywords">${this.currentKeywords}</span>`;
              // 防止XSS攻击
              newItem.hName = strEntity
                .encode(item.name.replace(reg, placeholder))
                .replace(pReg, str);
              newItem.title = `${item.name} ${item.id}`;
            }

            return newItem;
          });

          this.records.push(...records);
          this.index += 1;
          this.showLoadMore = false;
          this.searching = false;
          this.loading = false;
        })
        .catch((res) => {
          this.$message.error(res.message || '获取数据失败');
          this.tip = '获取数据失败';
          this.showLoadMore = false;
          this.searching = false;
          this.loading = false;
        });

      // return defer;
    },

    searchReq() {
      const { currentKeywords: keywords, index, count } = this;
      let defer;

      if (this.custFetchSearch) {
        defer = this.custFetchSearch({
          keywords,
          index,
          count,
        });
      } else {
        defer = this.$ajax.post('/mng/org/getUserTreeNodes', {
          keywords,
          current_page: index,
          items_per_page: count,
          // count: this.count,
          // index: this.index
        });
      }

      return defer;
    },
  },
};
</script>
